// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"790":"forms","845":"profile","930":"tables"}[chunkId] + "-legacy." + {"790":"ebff83ea","845":"2f479617","930":"38913a5d"}[chunkId] + ".js";
};